export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID ?? '',
      userPoolClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID ?? '',
      identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID ?? '',
      loginWith: { phone: true },
      passwordFormat: { minLength: 6 },
    },
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET ?? '',
      region: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET_REGION ?? '',
    },
  },
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT ?? '',
      region: process.env.REACT_APP_AWS_PROJECT_REGION ?? '',
      defaultAuthMode: 'userPool' as const,
    },
  },
};

// The participant chat service is a SEPARATE AppSync API from awsConfig.API.GraphQL
// (external serverless-chat-backend), authenticated via OIDC with the Cognito idToken.
// When the endpoint is not provisioned for an environment, chat fails closed
// (useChatEnabled returns false) rather than falling back to another endpoint.
export const chatConfig = {
  endpoint: process.env.REACT_APP_CHAT_APPSYNC_GRAPHQL_ENDPOINT ?? "",
  region: process.env.REACT_APP_CHAT_APPSYNC_REGION ?? "",
};

export const launchDarklyConfig = {
  clientSideID: process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID || "",
};

export const pendoConfig = {
  apiKey: process.env.REACT_APP_PENDO_KEY || "",
  // Not consumed at runtime; reserved for the Pendo CSP allowlist
  // (pendo-static-<subscriptionId>.storage.googleapis.com), which is applied
  // at the CloudFront/WAF layer. Kept here so the env var is documented.
  subscriptionId: process.env.REACT_APP_PENDO_SUBSCRIPTION_ID || "",
};
